<template>
  <div>
    <validation-provider
      :name="'Nome ' + label"
      :rules="{ required: true }"
      v-slot="validationContext"
    >
      <b-form-group :label="'Nome ' + label" label-for="name + '_name'">
        <b-form-input
          :name="name + '_name'"
          v-model="value.name"
          :state="validateState(validationContext)"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <b-row>
      <b-col md="6">
        <validation-provider
          :name="name + '_Email'"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-form-group label="Email" label-for="email">
            <b-form-input
              :name="name + '_email'"
              type="email"
              v-model="value.email"
              :state="validateState(validationContext)"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col md="6">
        <validation-provider
          :name="name + '_Telefone'"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-form-group label="Telefone" label-for="phone">
            <b-form-input
              :name="name + '_phone'"
              type="text"
              v-model="value.phone"
              :state="validateState(validationContext)"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Base from "./base";
export default {
  name: "ParentsData",
  extends: Base,
  props: {
    label: {
      type: String,
      required: true,
    },
    name
  },
};
</script>
